import React, { useEffect, useState } from 'react';
import { useOrderByIdQuery } from '../../../Store/Apis/bookingApi';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import formatDate from '../../../Hooks/formatDate';
import { useTaxPercentageQuery } from '../../../Store/Apis/toolsApi';

const PrintCreditNote = () => {
    const user = useSelector((state) => state.auth.user);
    const [logoLoaded, setLogoLoaded] = useState(false);
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('id');

    const orderByIdApi = useOrderByIdQuery({ keyID: orderId });
    const taxPercentageApi = useTaxPercentageQuery();

    const orderData = orderByIdApi?.data?.data?.[0] || {};
    const taxPercentage = Number(taxPercentageApi?.data?.data?.masterValue) || 0;
    const taxAmount = orderData.subTotal ? (orderData.subTotal * taxPercentage) / 100 : 0;
    const subtotal = taxPercentageApi.isSuccess ? (orderData.subTotal || 0) + taxAmount : orderData.subTotal || 0;
    const grossTotal = subtotal - (orderData?.discount || 0);
    const refundAmount = orderData?.amountPaid || 0;

    useEffect(() => {
        const sidenav = document.querySelector('aside.sidenav');
        const mainContent = document.querySelector('.sidenav.fixed-start + .main-content');
        const navbar = document.querySelector('.navbar-main');

        if (sidenav) sidenav.style.display = 'none';
        if (mainContent) mainContent.style.marginLeft = '0';
        if (navbar) navbar.style.display = 'none';
    }, []);

    useEffect(() => {
        if (orderByIdApi.isSuccess && logoLoaded) {
            window.print();
            const handleAfterPrint = () => {
                window.close();
            };
            window.addEventListener('afterprint', handleAfterPrint);
            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [orderByIdApi.isSuccess, logoLoaded]);

    if (!orderByIdApi.isSuccess) {
        return null;
    }

    return (
        <div className='a4-container' id="credit-note">
            <div className="card-body">
                <div className="page-wrapper">
                    <table className="table table-borderless">
                        <thead>
                            <tr>
                                <td colSpan="3">
                                    <img 
                                        src={user?.logo} 
                                        alt="" 
                                        height={50} 
                                        className='mb-2' 
                                        onLoad={() => setLogoLoaded(true)} 
                                    />
                                    <h5 className="company-name">{orderData.outletName}</h5>
                                    <p className="small-text">{orderData.outletPhone}</p>
                                    <p className="small-text">{orderData.outletAddress}</p>
                                </td>
                                <td colSpan="2" className="text-end">
                                    <h6 className="fw-bold">Credit Note ID: CN-{orderData.orderNumber}</h6>
                                    <p className="small-text">Issue Date: {formatDate(new Date())}</p>
                                    <p className="small-text">Reason: Order Cancelled by Business</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" className="text-center">
                                    <h4 className="title">CREDIT NOTE</h4>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="3">
                                    <h6 className="fw-500">Issued To:</h6>
                                    <p className="small-text">{orderData.customerName}</p>
                                    <p className="small-text">{orderData.customerNumber}</p>
                                    <p className="small-text">{orderData.email}</p>
                                    <p className="small-text">GST No: {orderData.gstNo}</p>
                                </td>
                                <td colSpan="2" className="align-top">
                                    <h6 className="fw-500 mb-2">Refund Details:</h6>
                                    <div className="d-flex justify-content-between">
                                        <span>Total Order Amount:</span>
                                        <span>R {grossTotal.toFixed(2)}</span>
                                    </div>
                                     {/* <div className="d-flex justify-content-between">
                                        <span>Tax Amount:</span>
                                        <span>R {taxAmount.toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Discount Amount:</span>
                                        <span>R {(orderData?.discount || 0).toFixed(2)}</span>
                                    </div>  */}
                                    <div className="d-flex justify-content-between">
                                        <span>Amount Paid:</span>
                                        <span>R {refundAmount.toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Refund Amount:</span>
                                        <span className="fw-bold">R {refundAmount.toFixed(2)}</span>
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Separate service details table */}
                    <table className="table table-bordered mt-4">
                        <thead>
                            <tr className="bg-light">
                                <th className="text-uppercase text-secondary text-dark text-center px-3 text-sm">#</th>
                                <th className="text-uppercase text-secondary text-dark text-center text-sm">Items</th>
                                <th className="text-uppercase text-secondary text-dark text-center text-sm">Rate</th>
                                <th className="text-uppercase text-secondary text-dark text-center text-sm">QTY</th>
                                <th className="text-uppercase text-secondary text-dark text-center text-sm">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderByIdApi.data.data[0].serviceTypeAndName && orderByIdApi.data.data[0].serviceTypeAndName.length > 0 ? (
                                orderByIdApi.data.data[0].serviceTypeAndName.map((service, index) => (
                                    <tr key={service.serviceID} style={{ borderBottom: '1px solid #ddd' }}>
                                        <td className="px-3 py-2 text-center">{index + 1}</td>
                                        <td className="text-center">
                                            <div className="mb-0">
                                                <strong>{service.serviceName}</strong>
                                            </div>
                                            <div className="mb-0 text-sm">{service.productServiceName}</div>
                                            <div className="mb-0 text-sm">{service.serviceCode}</div>
                                        </td>
                                        <td className="text-center">{-service.rate.toFixed(2)}</td>
                                        <td className="text-center">{-service.quantity}</td>
                                        <td className="text-center">{-(service.rate * service.quantity).toFixed(2)}</td>
                                    
                                    </tr>
                                
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No services found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <p className='footer-text'>
                        Thank you for your understanding. Please allow 3-5 business days for the refund to reflect in your account.
                        <br /> Powered by <b>Gert Sibande</b>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrintCreditNote;
